import { render } from "./SaldoHeader.vue?vue&type=template&id=76cafa54"
import script from "./SaldoHeader.vue?vue&type=script&lang=js"
export * from "./SaldoHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WORK\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__